import { Link, useLocation } from 'react-router-dom';

export function Footer() {
  const location = useLocation();
  const currentYear = new Date().getFullYear();

  const navItems = [
    { to: '/game', label: 'Play', icon: '🎮' },
    { to: '/leaderboard', label: 'Leaderboard', icon: '🏆' },
    { to: '/how-to-play', label: 'How to Play', icon: '📖' },
    { to: '/profile#achievements', label: 'Achievements', icon: '⭐' },
    { to: '/profile', label: 'Profile', icon: '👤' },
  ];

  return (
    <footer className="fixed bottom-0 left-0 right-0 bg-surface border-t border-gray-200 dark:border-gray-700 z-40">
      <div className="container mx-auto px-4 py-2 max-w-7xl">
        {/* Mobile: horizontal layout */}
        <div className="flex sm:hidden flex-row items-center justify-between gap-2">
          {/* Navigation Links */}
          <nav className="flex items-center space-x-4 flex-1 justify-center" aria-label="Main navigation">
            {navItems.map((item) => {
              const isActive = item.to === '/profile#achievements'
                ? location.pathname === '/profile' && location.hash === '#achievements'
                : location.pathname === item.to;
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  aria-current={isActive ? 'page' : undefined}
                  aria-label={item.label}
                  className={`
                    flex items-center space-x-1.5 text-xs font-medium transition-colors
                    focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 rounded-md p-1
                    ${isActive 
                      ? 'text-primary' 
                      : 'text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary'
                    }
                  `}
                >
                  <span className="text-base" aria-hidden="true">{item.icon}</span>
                </Link>
              );
            })}
          </nav>

          {/* Copyright - Right aligned on mobile */}
          <div className="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap">
            © {currentYear} Aspireworks, Inc.
            <span className="ml-1 text-gray-400 dark:text-gray-500">v{__BUILD_VERSION__}</span>
          </div>
        </div>

        {/* Desktop: vertical layout, centered */}
        <div className="hidden sm:flex flex-col items-center justify-center gap-1">
          {/* Navigation Links - Centered */}
          <nav className="flex items-center space-x-6" aria-label="Main navigation">
            {navItems.map((item) => {
              const isActive = item.to === '/profile#achievements'
                ? location.pathname === '/profile' && location.hash === '#achievements'
                : location.pathname === item.to;
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  aria-current={isActive ? 'page' : undefined}
                  className={`
                    flex items-center space-x-1.5 text-sm font-medium transition-colors
                    focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 rounded-md px-2 py-1
                    ${isActive 
                      ? 'text-primary' 
                      : 'text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary'
                    }
                  `}
                >
                  <span className="text-lg" aria-hidden="true">{item.icon}</span>
                  <span>{item.label}</span>
                </Link>
              );
            })}
          </nav>

          {/* Copyright - Below navigation on desktop */}
          <div className="text-xs text-gray-500 dark:text-gray-400">
            © {currentYear} Aspireworks, Inc.
            <span className="ml-1 text-gray-400 dark:text-gray-500">v{__BUILD_VERSION__}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
